export const BASE_URL = process.env.REACT_APP_BASE_URL_API
export const MFA_REDIRECT_URL = process.env.REACT_APP_MFA_REDIRECT_URL
export const MFA_LOGOUT_URL = process.env.REACT_APP_MFA_LOGOUT_URL
export const MFA_UPDATE_PASSWORD_URL = process.env.REACT_APP_MFA_SETTINGS_URL
export const WIRES_TEMPLATES_SENDER_BANKER_BIC = "TDPRUS33XXX"
/************** Login ********************/
export const AUTHENTICATE_MFA_URL = `${BASE_URL}/public/v1/mfaauthenticate`;
export const AUTHENTICATE_URL = `${BASE_URL}/public/v1/authenticate`;
export const REFRESH_URL = `${BASE_URL}/v1/refreshToken`;
export const RESET_URL = `${BASE_URL}/v1/user/password/reset`;
export const RESET_EXPIRED_URL = `${BASE_URL}/public/v1/user/password/expiredPasswordReset`;
export const LOGOUT_PATHNAME =  '/logout';

/************** Notifications ********************/
export const NOTIFICATIONS_URL = `${BASE_URL}/v1/notifications`;
export const NOTIFICATIONS_ALERTS_URL = `${BASE_URL}/v1/notifications/alerts`;
export const NOTIFICATIONS_ALERTS_UNREAD_COUNT_URL = `${BASE_URL}/v1/notifications/unread/count`;
export const NOTIFICATIONS_CLEAR_ALL_UNREAD_COUNT_URL = `${BASE_URL}/v1/notifications/clearAll`;
export const NOTIFICATIONS_DECREMENT_READ_COUNT_URL = `${BASE_URL}/v1/notifications/decrementCount`;
export const NOTIFICATIONS_ALERTS_READ_URL = `${BASE_URL}/v1/notifications/alerts/alert/read`;

/************** Preferences ********************/
export const PREFERENCES_URL = `${BASE_URL}/v1/user/preferences`;

/************** Report ********************/
export const REPORT_FOLDERS_URL = `${BASE_URL}/v1/reports/folders`;
export const REPORT_FOLDERS_FILES_URL = `${BASE_URL}/v1/reports/folders/folder/files`;
export const REPORT_FOLDERS_FILES_FILE_URL = `${BASE_URL}/v1/reports/folders/folder/files/file`;
export const REPORT_SAVED_REPORTS_URL = `${BASE_URL}/v1/reports/report/save`;

/************** Query ********************/
export const QUERIES = `${BASE_URL}/v1/queries`;
export const QUERIES_QUERY = `${BASE_URL}/v1/queries/query`;
export const QUERIES_QUERY_SAVE = `${BASE_URL}/v1/queries/query/save`;
export const QUERIES_QUERY_SAVED_USER = `${BASE_URL}/v1/queries/query/saved/user`;

/************** SSA ********************/
export const SHORT_SALE_URL_LOCATE = `${BASE_URL}/v1/sl/shortsale/weblocate`;
export const SHORT_SALE_URL_SEARCH_APPROVALS = `${BASE_URL}/v1/sl/shortsale/webapprovals`;
export const SHORT_SALE_URL_UPLOAD_FILE = `${BASE_URL}/v1/sl/shortsale/upload/validate`;
export const SHORT_SALE_URL_PERSIST_FILE = `${BASE_URL}/v1/sl/shortsale/upload/persist`;
export const SHORT_SALE_URL_GET_PERSIST_FILES = `${BASE_URL}/v1/sl/shortsale/upload/webLocateFiles`;
export const SHORT_SALE_URL_GET_PERSIST_FILE_DETAILS = `${BASE_URL}/v1/sl/shortsale/upload/webLocateFileDetails`;
export const SHORT_SALE_URL_DELETE_PERSIST_FILE = `${BASE_URL}/v1/sl/shortsale/upload/deleteWebLocateFile`;
export const SHORT_SALE_URL_RENAME_PERSIST_FILE = `${BASE_URL}/v1/sl/shortsale/upload/renameWebLocateFile`;

/************** Trades ********************/
export const TRADES_LIST_URL = `${BASE_URL}/v1/trades-list/`;
export const TRADES_SAVED_LIST_URL = `${BASE_URL}/v1/trades-list/save`;
export const TRADES_UPDATE_LIST_NAME_URL = `${BASE_URL}/v1/trades-list/save`;
export const TRADES_DELETE_LIST_URL = `${BASE_URL}/v1/trades-list/save`;
export const TRADES_SEARCH_URL = `${BASE_URL}/v1/trades/search`;
export const TRADES_SAVE_URL = `${BASE_URL}/v1/trades/save`;
export const TRADES_UPLOAD_VALIDATE_URL = `${BASE_URL}/v1/trades/upload/validate`;
export const TRADES_UPLOAD_SAVE_URL = `${BASE_URL}/v1/trades/upload/save`;
export const TRADES_REBOOK_URL = `${BASE_URL}/v1/trades/rebook`;
export const TRADES_CANCEL_URL = `${BASE_URL}/v1/trades/cancel`;
export const TRADES_LIST_TRADE_BREAKS = `${BASE_URL}/v1/trades-break/list`;
export const TRADES_BREAK_DETAIL_URL = `${BASE_URL}/v1/trades-break/detail`;


/************** Asset Transfer ********************/
export const ASSET_TRANSFER_LIST_URL = `${BASE_URL}/v1/assetTransfer`;
export const ASSET_TRANSFER_SAVED_LIST_URL = `${BASE_URL}/v1/assetTransfer/save`;
export const ASSET_TRANSFER_UPDATE_LIST_NAME_URL = `${BASE_URL}/v1/assetTransfer/save`;
export const ASSET_TRANSFER_DELETE_LIST_URL = `${BASE_URL}/v1/assetTransfer/save`;
export const ASSET_TRANSFER_SEARCH_URL = `${BASE_URL}/v1/assetTransfer/search`;
export const ASSET_TRANSFER_UPLOAD_SAVE_URL = `${BASE_URL}/v1/assetTransfer/upload/save`;
export let ASSET_TRANSFER_UPLOAD_VALIDATE_URL = `${BASE_URL}/v1/assetTransfer/upload/validate`;
export const ASSET_TRANSFER_LOAD_TEMPLATES = `${BASE_URL}/v1/assetTransfer/load/template`;
export const ASSET_TRANSFER_PROCESS_URL = `${BASE_URL}/v1/assetTransfer/process`;
export const ASSET_TRANSFER_AMEND_URL = `${BASE_URL}/v1/assetTransfer/amend`;
export const ASSET_TRANSFER_SAVE_URL = `${BASE_URL}/v1/assetTransfer/save`;
export const ASSET_TRANSFER_CANCEL_URL = `${BASE_URL}/v1/assetTransfer/cancel`;
export const ASSET_TRANSFER_BATCH_UPLOAD = `${BASE_URL}/v1/assetTransfer/batch/upload`;


/************** Swift Wires ********************/
export const SWIFT_WIRES_SEARCH_URL = `${BASE_URL}/v1/swiftWires/search`;
export const SWIFT_WIRES_PROCESS_URL = `${BASE_URL}/v1/swiftWires/process`;
export const SWIFT_WIRES_AMEND_URL = `${BASE_URL}/v1/swiftWires/amend`;
export const SWIFT_WIRES_SAVE_URL = `${BASE_URL}/v1/swiftWires/save`;
export const SWIFT_WIRES_CANCEL_URL = `${BASE_URL}/v1/swiftWires/cancel`;

/************** Broker ********************/
export const BROKER_SEARCH_URL = `${BASE_URL}/v1/broker/manager`;
export const BROKER_MPIDS_BY_MANAGER_URL = `${BASE_URL}/v1/broker/getBrokerMpidByManagerId`;

/************** Security ********************/
export const SECURITY_SEARCH_URL = `${BASE_URL}/v1/security/search`;
export const SECURITY_SEARCH_OPTIONS_URL = `${BASE_URL}/v1/security/search/options`;

/************** Security ********************/
export const CURRENCY_LIST_URL = `${BASE_URL}/v1/currency`;
export const CURRENCY_LIST_UNIQUE_URL = `${BASE_URL}/v1/currency/unique`;
export const COUNTRY_LIST_UNIQUE_URL = `${BASE_URL}/v1/countryCode`;
export const COUNTRY_LIST_COUNTRY_NAME = `${BASE_URL}/v1/countryCodeCountryName`;


/************** Wires ********************/
export const WIRES_WIRE_SEARCH = `${BASE_URL}/v1/wires/search`;
export const WIRES_TEMPLATES_SENDER_BANKER_BIC_DEFAULT = `${WIRES_TEMPLATES_SENDER_BANKER_BIC}`
export const WIRES_TEMPLATES_URL = `${BASE_URL}/v1/wires/templates`;
export const WIRES_SAVE_URL = `${BASE_URL}/v1/wires/wire`;
export const WIRES_LIST = `${BASE_URL}/v1/wires/list`;
export const WIRES_WIRES_LIST_SAVE = `${BASE_URL}/v1/wires/list/save`;
export const WIRES_SAVED_WIRES_LIST_URL = `${BASE_URL}/v1/wires/list`;
export const WIRES_CURRENCY_URL =`${BASE_URL}/v1/wires/currencies`;
export const WIRES_APPROVERS = `${BASE_URL}/v1/wires/accounts/approvals`;
export const WIRES_APPROVE_REJECT_VALIDATE = `${BASE_URL}/v1/wires/accounts/approveRejectValidate`;
export const WIRES_APPROVE_REJECT_VALIDATE_AND_APPROVE_REJECT = `${BASE_URL}/v1/wires/accounts/approveRejectValidateAndApproveReject`;

export const WIRES_APPROVE_REJECT = `${BASE_URL}/v1/wires/approveReject`;

/*******************HOME******************/
export const HOME_TOP_LONG_POSITIONS = `${BASE_URL}/v1/positions/top/long`;
export const HOME_TOP_SHORT_POSITIONS = `${BASE_URL}/v1/position/top/short`;
export const HOME_ACCOUNT_BALANCES = `${BASE_URL}/v1/account/balance`;
export const HOME_USERS_CLIENTREP = `${BASE_URL}/public/v1/clientmaster/users/client_rep/user`;

/******************FOOTER*******************/
export const FOOTER_REPORTS_URL = `${BASE_URL}/public/v1/footerReports`;

/******************COMMON*******************/
export const COMMON_BUS_DATES = `${BASE_URL}/public/v1/common/busDates`;
export const FOOTER_BASE_URL = process.env.REACT_APP_FOOTER_PDF_PATH
export const FOOTER_BASE_FIN_STMT_0330 = 'TDPS_Financial_Statements_0330.pdf';
export const FOOTER_BASE_CP_DISCLM_0330 = 'TDPS_Client_Portal_Disclaimers_and_Disclosures_0330.pdf';
export const FOOTER_BASE_FIN_STMT_108 = 'TDPS_Financial_Statements_108.pdf';
export const FOOTER_BASE_CP_DISCLM_108 = 'TDPS_Portal_Disclaimers_108.pdf';


/****************** MONEY-WIRES *******************/
export const MNY_WIRE_LIST_URL = `${BASE_URL}/v1/admin/mnywires/search/pend`;
export const MNY_WIRE_SEARCH_URL = `${BASE_URL}/v1/admin/mnywires/search`;
export const MNY_WIRE_APPR_URL = `${BASE_URL}/v1/admin/mnywires/list/appr`;
export const MNY_WIRE_REJ_URL = `${BASE_URL}/v1/admin/mnywires/list/rej`;


/****************** WIRES Template *******************/
export const WIRE_TEMPLATE_SEARCH_URL = `${BASE_URL}/v1/admin/wire-template/search`;
export const WIRE_TEMPLATE_SEARCH_PEND_URL = `${BASE_URL}/v1/admin/wire-template/search/pend`;
export const WIRE_TEMPLATE_SEARCH_APPROVE_URL = `${BASE_URL}/v1/admin/wire-template/search/approve`;
export const WIRE_TEMPLATE_LIST_URL = `${BASE_URL}/v1/admin/wire-template/list`;
export const WIRE_TEMPLATE_LIST_APPR_URL = `${BASE_URL}/v1/admin/wire-template/list/appr`;
export const WIRE_TEMPLATE_LIST_REJ_URL = `${BASE_URL}/v1/admin/wire-template/list/rej`;
export const WIRE_TEMPLATE_LIST_DEL_URL = `${BASE_URL}/v1/admin/wire-template/list/del`;
export const WIRE_TEMPLATE_LIST_UPD_URL = `${BASE_URL}/v1/admin/wire-template/list/upd`;
export const WIRE_TEMPLATE_CREATE_URL = `${BASE_URL}/v1/admin/wire-template/template`;


/****************** WebAnnouncements *******************/
export const WEB_ANNOUNCEMENTS_LISTS_URL = `${BASE_URL}/v1/admin/webAnnouncements`;
export const WEB_ANNOUNCEMENTS_CREATE_URL = `${BASE_URL}/v1/admin/webAnnouncements/webAnnouncement`;

export const WEB_ANNOUNCEMENTS_UPDATE_URL = `${BASE_URL}/v1/admin/webAnnouncements/update`;

export const WEB_ANNOUNCEMENTS_UPDATES_URL = `${BASE_URL}/v1/admin/webAnnouncements/updates`;

export const WEB_ANNOUNCEMENTS_DELETE_URL = `${BASE_URL}/v1/admin/webAnnouncements/delete`;

/****************** Swift *******************/
export const SWIFT_MESSAGE_URL_SEARCH = `${BASE_URL}/v1/swift/messages/search/all`;
export const SWIFT_TRANSACTION_URL_SEARCH = `${BASE_URL}/v1/swift/transactions/search`;
export const SWIFT_TRANSACTION_URL_COMPLETE = `${BASE_URL}/v1/swift/transactions/complete`;
export const SWIFT_TRANSACTION_URL_REJECT = `${BASE_URL}/v1/swift/transactions/reject`;
export const SWIFT_WIRES_URL_SEARCH = `${BASE_URL}/v1/swift/wires/search`;
export const SWIFT_WIRES_URL_COMPLETE = `${BASE_URL}/v1/swift/wires/complete`;



